import { render } from "./DashboardSales.vue?vue&type=template&id=e204008e&scoped=true"
import script from "./DashboardSales.vue?vue&type=script&lang=js"
export * from "./DashboardSales.vue?vue&type=script&lang=js"

import "./DashboardSales.vue?vue&type=style&index=0&id=e204008e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e204008e"]])

export default __exports__